import React from 'react'
import { Chart } from "react-google-charts";
import {shadeDefault} from '../InsightsColors';
import { addChartAnnotations, mergeChartOptions, replaceTrailingZerosWithNull} from '../insights_functions';

const InsightPieGraphView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        const rawData = viewData.ViewData[currentOption].ChartData;
        // Empty results can contain only the axis header, with no series columns.
        if (rawData.length < 2 || rawData[0].length < 2) {
            console.debug("InsightPieGraphView empty data", { currentOption, rowCount: rawData.length });
            return (
                <div role="status" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                    No data available
                </div>
            );
        }

        const chartType = viewData.ChartConfig?.chartType || "PieChart";
        const defaultChartOptions = {
                    bar: { groupWidth: "75%" },
                    legend: { position: "right" },
                    hAxis: { title: viewData.X_AXIS_Title },
                    vAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    colors: shadeDefault,
                    is3D: false,
                    pieSliceText: 'percent', // <-- Show value and percent on each slice
                    tooltip: { trigger: 'focus' },        // Show tooltip on hover (default)
                    pieHole: 0,
                    
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                    chartArea: {
                        left: 10,
                        top: 10,
                        right: 10,
                        bottom: 10,
                        width: '90%',
                        height: '90%'
                    }
                };

        const chartOptions = mergeChartOptions(defaultChartOptions, viewData.ChartConfig?.options);

        const normalizedChartData = replaceTrailingZerosWithNull(rawData);
        const chartData = addChartAnnotations(normalizedChartData, viewData.ChartConfig?.annotation);

        const chartFormatters = viewData.ChartConfig?.formatters || [];

        // Trailing zero values become null during normalization.
        const chartDataFormatted = chartData.map((row, idx) =>
            idx === 0 ? row : [row[0], row[1] === null ? null : Number(row[1].toFixed(2))]
        );

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        console.log("layout response view", viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData, chartDataFormatted);

        return (
            <Chart
                chartType={chartType}
                data={chartDataFormatted}
                options={chartOptions}
                formatters={chartFormatters}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightPieGraphView
